export const START_ROUTE_PATH = 'start'

export const DOCUMENTS_ROUTE_PATH = 'documents'
export const AUTOGIRO_ROUTE_PATH = 'autogiro'
export const LETTER_ROUTE_PATH = 'brev'
export const LOAN_ROUTE_PATH = 'låna'
export const KYC_ROUTE_PATH = 'kundkännedom'

export interface IEnvironment {
  production: boolean
  apiUrl: string //'https://api-bo-daniel.internal.sparbankensyd.se/api',
  rtUrl: string //'https://api-rt-prod.internal.sparbankensyd.se/api',
  authServiceUrl: string //'https://spb-common-api-daniel.internal.sparbankensyd.se/service',
  domain: string // 'bo.internal.sparbankensyd.se',
  /**
   * This effectively prevents the start page to be shown.
   * You will end up on the documents page in production.
   * Need to check with Johanna and Maria what to do with this.
   */
  nextGeneration: boolean //false,
  /**
   * Features shown in test only
   */
  testMode: boolean //false,

  /**
   * Features for Developers only
   */
  developerMode: boolean // false
}